import { useMutation } from '@tanstack/react-query';

import {
  useRequest,
  type MutationFunction,
  type MutationFunctionContext,
  type RequestQueryObject,
} from '@frontend/api';

import type { Rule, RuleDetailsError } from './types';

const useUpdateRuleKey = ['rules', 'update'] as const;
export const getUseUpdateRuleKey = () => useUpdateRuleKey;

/**
 * Mutation function for updating a rule.
 */
export const useUpdateRule: MutationFunction<
  Rule,
  Rule,
  [],
  RequestQueryObject,
  RuleDetailsError
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation<
    Rule,
    RuleDetailsError,
    Rule,
    MutationFunctionContext<Rule>
  >({
    mutationFn: ({ uuid, ...body }) =>
      request<Rule>(`/rules/${uuid}`, {
        init: {
          method: 'PATCH',
          body,
        },
      }),
    ...queryOptions,
    mutationKey: getUseUpdateRuleKey(),
  });
};
